import type { BlockPlugin } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const registry = new Map<string, BlockPlugin<any>>();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function registerBlockPlugin(plugin: BlockPlugin<any>): void {
    if (registry.has(plugin.name)) {
        console.warn(
            `BlockPlugin "${plugin.name}" is already registered. Overwriting.`
        );
    }
    registry.set(plugin.name, plugin);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getBlockPlugin(name: string): BlockPlugin<any> | undefined {
    return registry.get(name);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getAllBlockPlugins(): BlockPlugin<any>[] {
    return Array.from(registry.values());
}

export function getBlockPluginsByCategory(
    category: 'component' | 'break'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
): BlockPlugin<any>[] {
    return getAllBlockPlugins().filter(
        (p) => p.toolbarInsert?.category === category
    );
}
